import type { CheckboxOption } from '~/client/components/containers/PcfraCreateEditPage/form/ConditionalFormInput';

export const fireRiskFactorOptions = [
  {
    id: 'smoking',
    label:
      'Smoking - with signs of unsafe use of smoking or vaping materials (e.g. smoking in bed)',
  },
  {
    id: 'flammableCreams',
    label: 'Use of emollient creams that are petroleum or paraffin based',
  },
  { id: 'oxygen', label: 'Air pressure mattress or oxygen cylinders are used' },
  {
    id: 'unsafePortableHeaters',
    label:
      'Unsafe use of portable heaters (e.g. placed too close to materials that could catch fire)',
  },
  { id: 'unsafeCooking', label: 'Unsafe cooking practices (e.g. cooking left unattended)' },
  {
    id: 'overloadedElectrics',
    label: 'Overloaded electrical sockets/adaptors or extension leads',
  },
  { id: 'faultyWiring', label: 'Faulty or damaged wiring' },
  { id: 'electricBlankets', label: 'Electric blankets used' },
  {
    id: 'previousIncidents',
    label: 'Previous fires or near misses, burns or scorch marks on carpets and furniture',
  },
  {
    id: 'unsafeNakedFlames',
    label:
      'Unsafe candle/tea light use (e.g. too close to curtains, within reach of children or pets)',
  },
] as const satisfies CheckboxOption[];

export const reactionRiskFactorOptions = [
  {
    id: 'mentalHealth',
    label: 'Mental health issues (e.g. dementia, anxiety or depression)',
  },
  { id: 'cognitiveDifficulties', label: 'Cognitive or decision-making difficulties' },
  { id: 'substanceAbuse', label: 'Alcohol dependency or misuse of drug' },
  {
    id: 'sensoryImpairment',
    label: 'Sensory impairments (e.g. hard of hearing or sight loss) – please specify',
    isCustom: true,
  },
] as const satisfies CheckboxOption[];

export const escapeRiskFactorOptions = [
  {
    id: 'mobilityIssues',
    label: 'Have restricted mobility, are frail or have a history of falls',
  },
  { id: 'visuallyImpaired', label: 'Are blind or have impaired vision' },
  {
    id: 'understandingIssues',
    label: 'Lacks capacity to understand what to do in the event of a fire',
  },
  {
    id: 'hasClutter',
    label: 'Is a hoarder, or there are cluttered or blocked escape route (see Clutter Scale)',
  },
  { id: 'bedOrChairbound', label: 'Are bed or chairbound' },
  { id: 'leavesInternalDoorsOpen', label: 'Internal doors are left open at night' },
  { id: 'unableToUnlockDoor', label: 'Would be unable to unlock front door to escape' },
] as const satisfies CheckboxOption[];
